export function isBugBountyEmail(str) {
  const regex = /@bugcrowdninja\.com$/i;
  return regex.test(str);
}
